import { SubscriptionSchedule, SchedulerFrequency } from "../../../types";
import { messages } from "./SubscriptionsSettingsSchedule.messages";

export const DefaultScheduleFrequency = {
  [SchedulerFrequency.Dayly]: {
    frequency: SchedulerFrequency.Dayly,
    month: null,
    day: null,
    time: "12:00:00",
  },
  [SchedulerFrequency.Weekly]: {
    frequency: SchedulerFrequency.Weekly,
    month: null,
    day: 1,
    time: "12:00:00",
  },
  [SchedulerFrequency.Monthly]: {
    frequency: SchedulerFrequency.Monthly,
    month: null,
    day: 1,
    time: "12:00:00",
  },
  [SchedulerFrequency.Quarterly]: {
    frequency: SchedulerFrequency.Quarterly,
    month: 1,
    day: 1,
    time: "12:00:00",
  },
  [SchedulerFrequency.SemiAnnuality]: {
    frequency: SchedulerFrequency.SemiAnnuality,
    month: 1,
    day: 1,
    time: "12:00:00",
  },
  [SchedulerFrequency.Annuality]: {
    frequency: SchedulerFrequency.Annuality,
    month: 1,
    day: 1,
    time: "12:00:00",
  },
} as const;

export const DefaultSchedule: SubscriptionSchedule = DefaultScheduleFrequency[SchedulerFrequency.Dayly];

export const FrequencyOptions = [
  {
    id: SchedulerFrequency.Dayly,
    name: messages.frequencyDaily,
  },
  {
    id: SchedulerFrequency.Weekly,
    name: messages.frequencyWeekly,
  },
  {
    id: SchedulerFrequency.Monthly,
    name: messages.frequencyMonthly,
  },
  {
    id: SchedulerFrequency.Quarterly,
    name: messages.frequencyQuarterly,
  },
  {
    id: SchedulerFrequency.SemiAnnuality,
    name: messages.frequencySemiAnnually,
  },
  {
    id: SchedulerFrequency.Annuality,
    name: messages.frequencyAnnually,
  },
];

export const DaysOfWeekOptions = [
  { id: 1, name: messages.Monday },
  { id: 2, name: messages.Tuesday },
  { id: 3, name: messages.Wednesday },
  { id: 4, name: messages.Thursday },
  { id: 5, name: messages.Friday },
  { id: 6, name: messages.Saturday },
  { id: 6, name: messages.Sunday },
];

export const DaysOptions = Array(31)
  .fill(1)
  .map((_, i) => i + 1)
  .map((id) => ({ id, name: String(id) }));

export const MonthsOfQuarterOptions = Array(3)
  .fill(1)
  .map((_, i) => i + 1)
  .map((id) => ({ id, name: String(id) }));

export const MonthsOfHalfYearOptions = Array(6)
  .fill(1)
  .map((_, i) => i + 1)
  .map((id) => ({ id, name: String(id) }));

export const MonthsOptions = [
  { id: 1, name: messages.Jan },
  { id: 2, name: messages.Feb },
  { id: 3, name: messages.Mar },
  { id: 4, name: messages.Apr },
  { id: 5, name: messages.May },
  { id: 6, name: messages.Jun },
  { id: 7, name: messages.Jul },
  { id: 8, name: messages.Aug },
  { id: 9, name: messages.Sep },
  { id: 10, name: messages.Oct },
  { id: 11, name: messages.Nov },
  { id: 12, name: messages.Dec },
];
